import { request, gql } from "graphql-request";

import { CONTENTFUL_GRAPHQL_API_URL } from "@/utils/urls.ts";

const JIRA_PRODUCT_INTERNAL_TITLE = "Jira Cloud Product";

export const JiraTemplateCategoriesQuery = gql`
query {
  taxonomyTemplateCategoryCollection(
    limit: 100,
    where: {
      product: {
        internalTitle: "${JIRA_PRODUCT_INTERNAL_TITLE}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`;

export interface JiraTemplateCategoriesQueryResult {
    taxonomyTemplateCategoryCollection: {
        items: JiraTemplateCategory[];
    };
}

export interface JiraTemplateCategory {
    sys: {
        id: string;
    };
    categoryNameInternal: string;
    categoryNameExternal: string;
    urlSlug: string;
}

export const getTemplateCategories = () => {
    return request<JiraTemplateCategoriesQueryResult>({
        url: CONTENTFUL_GRAPHQL_API_URL,
        document: JiraTemplateCategoriesQuery,
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};
